// Generated by Claude Code
import { WorkOrderTemplatesPage } from '#components/domain/operations/work-orders/work-order-templates/work-order-templates-page.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionAction, PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/work-order-templates/')({
  component: RouteComponent,
  staticData: {
    title: 'Work Order Templates',
  },
})

/** Route guard: templates have no limited slots, so plain READ gates the page. */
function RouteComponent() {
  return (
    <PermissionGuard
      permissions={[[[PermissionService.WORK_ORDER_TEMPLATES, PermissionAction.READ]]]}
      redirectOnNotAuthorized
    >
      <WorkOrderTemplatesPage />
    </PermissionGuard>
  )
}
